import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { compare } from 'fast-json-patch';
import { ConfirmationService, SelectItem } from 'primeng';
import { CommsTemplateService, DelayFailureService } from '../../services';
import { IDelayFailureTemplate } from 'src/app/interfaces/delay-failure/delay-failure-template';

@Component({
  selector: 'delay-failure-templates',
  templateUrl: './delay-failure-templates.component.html',
  styleUrls: ['./delay-failure-templates.component.scss'],
})
export class DelayFailureTemplatesComponent implements OnInit {
  isLoaded = false;
  delayFailureTemplates: {}[] = [];
  responseSelected: IDelayFailureTemplate = null;
  editForm: FormGroup;
  showEditForm: boolean;
  editMode: boolean;
  private preEditForm: any;
  showHelp = false;
  wrapperOptions: SelectItem[];

  constructor(
    private delayFailureService: DelayFailureService,
    private confirmationService: ConfirmationService,
    private commsTemplateService: CommsTemplateService,
  ) {}

  ngOnInit() {
    this.initForm();
    this.loadDelayFailureTemplates();
    this.loadWrappers();
  }

  initForm() {
    this.editForm = new FormGroup({
      id: new FormControl(),
      headline: new FormControl(),
      templateWrapperId: new FormControl(),
      recipientAddressTemplate: new FormControl(),
      subjectTemplate: new FormControl(),
      bodyTemplate: new FormControl(),

      senderAddressTemplate: new FormControl(),
      senderNameTemplate: new FormControl(),

      replyToAddressTemplate: new FormControl(),
      replyToNameTemplate: new FormControl(),
    });
  }

  loadDelayFailureTemplates() {
    this.isLoaded = false;

    this.delayFailureService.getDelayFailureTemplates().then((x) => {
      this.delayFailureTemplates = x;

      this.showEditForm = false;
      this.isLoaded = true;
    });
  }

  loadWrappers() {
    this.commsTemplateService.fetchTemplateWrappers().then((x) => {
      this.wrapperOptions = x.map((item) => {
        return { label: item.templateName, value: item.id };
      });

      this.wrapperOptions.unshift({ label: 'No Wrapper', value: null });
    });
  }

  createQuestion() {
    this.showEditForm = true;
    this.editMode = false;
    this.editForm.reset();
  }

  deleteDelayFailureTemplate() {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this item?',
      header: 'Confirmation',
      icon: 'pi pi-question',
      accept: () => {
        this.deleteConfirmed();
      },
    });
  }

  deleteConfirmed() {
    this.delayFailureService.deleteDelayFailureTemplate(this.responseSelected.id).then((x) => {
      this.loadDelayFailureTemplates();
    });
  }

  editResponse(item) {
    this.showEditForm = true;
    this.responseSelected = item;
    this.editMode = true;
    this.editForm.patchValue(item);
    this.preEditForm = Object.assign(this.editForm.value);
  }

  get f() {
    return this.editForm.value;
  }

  saveResponse() {
    if (this.f.id > 0) {
      const patch = compare(this.preEditForm, this.editForm.value);

      this.delayFailureService
        .patchDelayFailureTemplate(this.responseSelected.id, patch)
        .then((x) => {
          this.loadDelayFailureTemplates();
        });
    } else {
      this.delayFailureService.createDelayFailureTemplate(this.editForm.value).then((x) => {
        this.loadDelayFailureTemplates();
      });
    }
  }
}
